const Credits = () =>{
    return(
        <div>
            <h1>
                Credits:
                Adlai Kagle and Ethan Baraf
                {/* have email, github idk */}
                
            </h1>
        </div>
    );
}

export default Credits;